/* eslint-disable max-classes-per-file */
/* eslint-disable camelcase */

import SecureLS from 'secure-ls'

class CryptedLS {
  encryption_secret = 'secret-password'

  secureLs = new SecureLS({ encodingType: 'aes', encryptionSecret: this.encryption_secret });
  // secureLs = ls

  constructor() {
  }

  setItem(key, value) {
    return this.secureLs.set(key, value)
  }

  getItem(key) {
    return this.secureLs.get(key)
  }

  removeItem(key) {
    this.secureLs.remove(key)
  }
}

export class LocalStorageService {
  key_mtca_route_to_redirect_to_after_login = 'route_to_redirect_to_after_login'

  key_jwt_access_token = 'accessToken'

  key_jwt_refresh_token = 'refreshTokenToken'

  key_userData = 'userData'

  key_test = 'test'

  /*
   In order to prevent JSON.parse errors while trying to parse string to object
   Is set to true when the default localstorage is the storage instance
   Is set to false when SecureLS is the storage instance ( SecureLS support object as well as Array thus there's no need to parse them anymore. The .get method do it automatically)
  */
  storeObjectAsString = true

  /*
  Basic local storage instance. The browser localStorage as is
  Uncomment the line bellow in developement only
  */
  localStorageInstance = localStorage

  /*
  Secure localStorage instance. Datas are encrypted and non human-readable
  This is the default instance for security purpose
  WIP : Should we encrypt the storage keys too ??
 */
  // localStorageInstance = new CryptedLS()

  // for test purpose
  setTest(value) {
    this.localStorageInstance.setItem(this.key_test, value)
    setTimeout(() => {
      // console.log('getTest', this.getTest())
    }, 2000)
  }

  getTest() {
    return this.localStorageInstance.getItem(this.key_test)
  }

  // jwt token
  setJwtToken(value) {
    this.localStorageInstance.setItem(this.key_jwt_access_token, value)
  }

  getJwtToken() {
    return this.localStorageInstance.getItem(this.key_jwt_access_token)
  }

  removeJwtToken() {
    this.localStorageInstance.removeItem(this.key_jwt_access_token)
  }

  // routeToRedirectToAfterLogin
  setRouteToRedirectToAfterLogin(value) {
    this.localStorageInstance.setItem(this.key_mtca_route_to_redirect_to_after_login, value)
  }

  getRouteToRedirectToAfterLogin() {
    return this.localStorageInstance.getItem(this.key_mtca_route_to_redirect_to_after_login)
  }

  removeRouteToRedirectToAfterLogin() {
    this.localStorageInstance.removeItem(this.key_mtca_route_to_redirect_to_after_login)
  }

  // jwt refresh token
  setJwtRefreshToken(value) {
    this.localStorageInstance.setItem(this.key_jwt_refresh_token, value)
  }

  getJwtRefreshToken() {
    return this.localStorageInstance.getItem(this.key_jwt_refresh_token)
  }

  removeJwtRefreshToken() {
    this.localStorageInstance.removeItem(this.key_jwt_refresh_token)
  }

  // jwt userdata
  setUserData(value) {
    if (this.storeObjectAsString) value = JSON.stringify(value)
    this.localStorageInstance.setItem(this.key_userData, value)
  }

  getUserData() {
    const item = this.localStorageInstance.getItem(this.key_userData)
    if (!this.storeObjectAsString) return item
    try {
      return JSON.parse(item)
    } catch (e) {
      return item
    }
  }

  getUserId(key) {
    const user = this.getUserData()
    if (user) {
      if (key) return user[key]
      return user.id
    }
    return user
  }

  removeUserData() {
    this.localStorageInstance.removeItem(this.key_userData)
  }

  clearAuthData() {
    this.removeJwtRefreshToken()
    this.removeJwtToken()
    this.removeUserData()
  }
}

// export an instance of the class
export default new LocalStorageService()
